// src/components/BuyNowAndAddToCartProduct/BuyNowAndAddToCartProduct.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BuyNowAndAddToCartProduct.css';
import {FaShoppingCart} from "react-icons/fa";


const BuyNowAndAddToCartProduct = ({ product }) => {
  const navigate = useNavigate();

  const handleAddToCart = () => {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const alreadyInCart = cart.find(item => item.id === product.id);

    if (!alreadyInCart) {
      cart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.images[0] // תמונה ראשית
      });
      localStorage.setItem('cart', JSON.stringify(cart));
    }

    alert('המוצר נוסף לסל ✔');
  };

  const handleBuyNow = () => {
    handleAddToCart();
    navigate('/cashout');
  };

  return (
    <div className="buy-buttons-container">
      <button className="buy-now-btn" onClick={handleBuyNow}>קנה עכשיו</button>
<button className="add-to-cart-btn" onClick={handleAddToCart}>
  הוסף לסל
  <FaShoppingCart style={{ marginRight: '8px', fontSize: '18px', verticalAlign: 'middle' }} />
</button>


    </div>
  );
};

export default BuyNowAndAddToCartProduct;
